// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"371":"e1831419","855":"2335abf2"}[chunkId] + ".chunk.css";
};